export const EVENT_ENDPOINT = '/calendar/filter';
export const CALENDAR_URL = '/events/calendar';
